import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from './useTexts'

export function NotificationLimitations() {
  const texts = useTexts()

  return (
    <Alert severity="warning">
      <AlertTitle>{texts.notificationLimitationTitle}</AlertTitle>
      {texts.notificationLimitationDescription}
    </Alert>
  )
}
